import { getValidChain, OChainId, TChainId } from 'modules/api';
import { useGlobalTranslation } from 'modules/i18n';

export const useConnectableChainName = () => {
  const { keys: globalKeys, t } = useGlobalTranslation();
  return {
    getConnectableChainName: (chainId?: TChainId) => {
      if (!chainId) return '';

      const chainIdNumber = Number(chainId);
      if (!isNaN(chainIdNumber)) {
        const validChain = getValidChain(chainIdNumber);
        return t(globalKeys.chain[validChain]);
      }

      return t(globalKeys.chain[OChainId.unsupported]);
    },
  };
};
